import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { MainMenuAppTransfer } from '../../constants/AppMenuConstants'
import { RxJSStateDefinable } from '../Types/Types'

const appMenuSubject: BehaviorSubject<Definable<MainMenuAppTransfer>> = new BehaviorSubject<
    Definable<MainMenuAppTransfer>
>(undefined)

RxJS.appMenuUpdate = RxJS.appMenuUpdate ?? {
    subject: appMenuSubject,
    observable: appMenuSubject.asObservable(),
    announce: (mainMenuApp?: MainMenuAppTransfer): void => {
        appMenuSubject.next(mainMenuApp)
    }
}

export const appMenuUpdate$: RxJSStateDefinable<MainMenuAppTransfer> = RxJS.appMenuUpdate
